namespace SP.Data {
    export class Dashboard {

        static async getDashboardInfo(dashboardId: string) {
            const response = await SP.get<any>("/api/v1/dashboard/get/" + dashboardId);
            
            if (response.status == 200) {
                return response.data as SP.DashboardSettings;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }
            
            return null;
        }

        static async updateDashboard(postData: any) {
            const response = await SP.post<any>("/api/v1/dashboard/update", postData);

            if (response.status == 200) {
                return response.status;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return response.status;
        }

    }
}